import React from "react";
import styled from "styled-components";
import CartItemNew from "./shared/CartItem/CartItemNew";

export default function ShipmentsListNew({ ship }) {
  const ShipmentContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 99%;
    border-radius: 8px;
    margin: 0.5rem 0;
    background-color: #fff;
    min-height: 200px;
    min-width: 300px;
    background-color: #fff;
    margin-right: 2rem;
    margin-top: unset;

  `;

  const ShipmentItemList = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
  `;

  console.log("ship", ship);

  const ShipmentItem = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  `;

  const ShipmentTop = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    padding: 0.2rem 1px;
  `;

  const ShipmentImageContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem 0.5rem;

    img {
      width: 130px;
      aspect-ratio: 1/1;
      object-fit: cover;
    }
  `;
  const ShimpentItemDetails = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    padding: 0.5rem 1rem;
    p {
      margin: 0;
    }
  `;

  const ShipmentPrice = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    font-size: 0.9rem;
    color: rgb(130, 130, 130);
    font-weight: 500;

    span:first-child {
      color: rgb(65, 65, 65);
      font-weight: 500;
      margin-right: 0.5rem;
      font-size: 1.2rem;
    }
    span:last-child {
      text-decoration: line-through;
      color: rgb(130, 130, 130);
      font-weight: 400;
    }
  `;
  const ShipmentButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem 0;
  
    `;

    const AddtoWishlistButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    outline: none;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    font-size: 0.85rem;
    width: 151px;
    height: 35px;
    cursor: pointer;
    background-color: #fff;
    color: rgb(125, 125, 125);


    @media (max-width: 900px) {
width: 95px;
font-size: 0.75rem;

}
    `
        const DeleteButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    outline: none;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    font-size: 0.85rem;
    width: 151px;
    height: 35px;
    cursor: pointer;
    background-color: #fff;
    color: rgb(125, 125, 125);
    margin-left: 1rem;
     @media (max-width: 900px) {
width: 95px;
font-size: 0.75rem;

}
    `

    

  return (
    <ShipmentContainer>
      <ShipmentItemList>
        {ship?.cartItemDetails?.map((item, index) => {
          return (
            <CartItemNew item={item} />
          );
        })}
      </ShipmentItemList>
    </ShipmentContainer>
  );
}
